<template>
    <div>
      <img src="../../../static/img/share_head.png" alt="">
      <div class="share__content">
        <p>招募说明：</p>
        <div class="share__details">
          <div>1. 充值股金成为分享合伙人,详细阅读<router-link :to="{path: 'tech_agreement',query:{type:1}}" class="col_45B9BC">《股东协议》</router-link></div>
          <div>2. 申请成为创客合伙人</div>
        </div>
      </div>
      <div class="share__btnBox">
        <router-link to="/gorecharge">分享合伙人</router-link>
        <router-link to="/partnerApply">创客合伙人</router-link>
      </div>
    </div>
</template>

<script>
  export default {
    name: "share"
  }
</script>

<style scoped>
  .share__content{
    padding: .75rem;
    font-size: .7rem;
    color: #333;
  }
  .share__details{
    font-size: .6rem;
    color: #999;
    padding: .35rem 0;
  }
  .share__details>div{
    padding: 1px 0;
  }
  .share__btnBox{
    padding: 15% 1rem 1rem;
    display: flex;
  }
  .share__btnBox>a{
    width: 100%;
    margin: 0 .5rem;
    text-align: center;
    background: #45B9BC;
    color: #fff;
    border-radius: .25rem;
    font-size: .9rem;
    line-height: 2rem;
  }
</style>



// WEBPACK FOOTER //
// src/views/index/share.vue